import { useQuery } from "@apollo/react-hooks";
import GET_ANALYTICS from "../api/analytics";
import getTimezoneOffset from "../utils/timezone";

// 傳給後端做月份分組，讓圖表的月界與花費列表的本地時間分組一致。
const timezoneOffset = getTimezoneOffset();

// 單筆最高消費「每個幣別」各取的筆數（server 依幣別分別排名）
const TOP_SPENDINGS_LIMIT = 5;

export default ({ months, startDate, endDate } = {}) => {
  const isCustomIncomplete = !months && (!startDate || !endDate);

  const { loading, error, data } = useQuery(GET_ANALYTICS, {
    variables: {
      months,
      startDate,
      endDate,
      timezoneOffset,
      topSpendingsLimit: TOP_SPENDINGS_LIMIT,
    },
    fetchPolicy: "cache-and-network",
    skip: isCustomIncomplete,
  });

  return {
    loading,
    error,
    monthlySpending: data && data.monthlySpending,
    categorySpending: data && data.categorySpending,
    monthlyCategorySpending: data && data.monthlyCategorySpending,
    noteSpending: data && data.noteSpending,
    topSpendings: data && data.topSpendings,
    currencySummary: data && data.currencySummary,
  };
};
